import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { detectCountry } from "@/lib/countryDetect";
import { countryFlag } from "@/components/admin/InstallsByCountryPanel";

// Lot 767 — bannière de bienvenue des visiteurs NON connectés d'un pays « relancé » (Admin › Utilisateurs › Résumés).
// Pays détecté par fuseau horaire / langue de l'appareil ; « vu » compté une fois par session, « clic » à chaque appui.
export const WelcomeCountryBanner = ({ lang, onRegister, country }) => {
  const [banner, setBanner] = useState(null);
  useEffect(() => {
    const code = country || detectCountry();
    if (!code) return;
    let alive = true;
    api.get(`/public/welcome-banner?country=${code}&lang=${lang || "fr"}`).then(({ data }) => {
      if (!alive || !data?.banner) return;
      setBanner(data.banner);
      const key = `yalola.relaunch.seen.${data.banner.id}`;
      try {
        if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, "1"); api.post(`/public/welcome-banner/${data.banner.id}/hit?kind=seen`).catch(() => {}); }
      } catch { /* stockage indisponible */ }
    }).catch(() => {});
    return () => { alive = false; };
  }, [lang, country]);
  if (!banner) return null;
  const click = () => { api.post(`/public/welcome-banner/${banner.id}/hit?kind=click`).catch(() => {}); onRegister?.(); };
  return (
    <div className="rounded-2xl p-4 mb-4 flex gap-3 items-start" style={{ background: "var(--yalola-primary-soft)", border: "1px solid var(--yalola-border)" }} data-testid="welcome-country-banner" data-country={banner.code}>
      <span className="text-3xl leading-none" aria-hidden="true">{countryFlag(banner.code) || <Sparkles size={24} />}</span>
      <div className="min-w-0 flex-1">
        <div className="font-bold font-display text-base" style={{ color: "var(--yalola-text)" }} data-testid="welcome-country-title">{banner.title}</div>
        <p className="text-sm mt-1 leading-relaxed" style={{ color: "var(--yalola-text-muted)" }} data-testid="welcome-country-body">{banner.body}</p>
        {banner.cta && <button type="button" onClick={click} className="pill pill-primary mt-3 text-sm" data-testid="welcome-country-cta">{banner.cta}</button>}
      </div>
    </div>
  );
};
